import * as Sentry from "@sentry/react";
import { freshChatHost, freshChatToken, freshChatSiteId, freshChatScript } from "config/constant";
declare global {
  interface Window {
    fcWidget: any;
  }
}

function load(externalId: number) {
  const initFreshChat = () => {
    // The script tag may exist while the SDK never loaded (e.g. CDN blocked by a
    // corporate proxy), leaving fcWidget undefined. Guard so we never throw on init.
    if (!window.fcWidget) return;
    window.fcWidget.init({
      token: freshChatToken,
      host: freshChatHost,
      siteId: freshChatSiteId,
      externalId: externalId,
      config: {
        cssNames: {
          widget: "proctoring_fc_frame"
        },
        headerProperty: {
          hideChatButton: true
        }
      }
    });
  };

  const createElement = (i: any, t: string, e: any) => {
    e = i.createElement("script");
    e.id = t;
    e.async = !0;
    e.src = freshChatScript;
    e.onload = initFreshChat;
    i.head.appendChild(e);
  };

  const initialize = (i: any, t: string) => {
    const existingScript = i.getElementById(t);
    if (existingScript && window.fcWidget) {
      initFreshChat();
      return;
    }
    if (existingScript) {
      existingScript.remove();
    }
    createElement(i, t, undefined);
  };
  initialize(document, "freshchat-js-sdk");
}

function _unload() {
  if (window.fcWidget) {
    window.fcWidget.off("widget:loaded");
    window.fcWidget.destroy();
    delete window.fcWidget;
  }
  document.getElementById("freshchat-js-sdk")?.remove();
}

const freshChatActions = {
  init: function (session_id: number) {
    // FreshChat is an optional support widget; a failure here (e.g. blocked CDN)
    // must never break the proctoring flow, so swallow and report any error.
    try {
      load(session_id);
    } catch (error) {
      Sentry.captureException(error);
    }
  },
  unload: function () {
    try {
      _unload();
    } catch (error) {
      Sentry.captureException(error);
    }
  }
};

export default freshChatActions;
